import * as types from '../constants/category';
import localStorage from 'store';

let initialState = {
  isLoading: 0,
  categories: localStorage.get('categories') ?? [],
  total: null,
  page: 1,
  perPage: 24,
  searched: null,
  productsLoading: true,
  filtersLoading: false,
  products: [],
  filters: [],
  sort: {
    type: 'price',
    direction: 'desc',
  },
  selectedFilters: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_LOADER:
      return {
        ...state,
        isLoading: payload ? state.isLoading + 1 : state.isLoading - 1,
      };
    case types.SET_CATEGORIES:
      return {
        ...state,
        categories: payload,
      };
    case types.SET_PAGE:
      return {
        ...state,
        page: payload,
      };
    case types.FETCH_FILTERS:
      return {
        ...state,
        ...payload,
        filtersLoading: false,
      };
    case types.SET_FILTERS_LOADER:
      return {
        ...state,
        filtersLoading: payload,
      };
    case types.FETCH_FILTERS_ERROR:
      return {
        ...state,
        filtersLoading: false,
      };
    case types.RESET_FILTERS:
      return {
        ...state,
        selectedFilters: {},
        filters: {},
        total: null,
        page: 1,
      };
    case types.SET_FILTER:
      return {
        ...state,
        selectedFilters: payload,
        page: 1,
      };
    case types.SET_PRODUCTS_LOADER:
      return {
        ...state,
        productsLoading: payload,
      };
    case types.SET_PRODUCTS:
      return {
        ...state,
        products: payload,
      };
    case types.SET_SELECTED_FILTERS:
      return {
        ...state,
        selectedFilters: payload.filters,
      };
    default:
      return state;
  }
};
